import { PhoneChatReplyOption, Scene } from '../types';

export interface PhoneBranchContinuation {
  playerText: string;
  contactReply?: string;
  gotoScene?: string;
}

export function isConvergeSceneId(sceneId: string): boolean {
  return sceneId.endsWith('--converge');
}

/**
 * Legacy support: a reply goto may point to a dialogue scene played inside the call.
 * In v2 conversations are self-contained (nested replyOptions), so this usually returns [].
 */
export function extractPhoneBranchContinuations(scene: Scene | undefined): PhoneBranchContinuation[] {
  if (!scene || isConvergeSceneId(scene.id)) return [];
  if (scene.type === 'dialogue' && scene.text?.trim() && !scene.isInternal) {
    return [{ playerText: scene.text, gotoScene: scene.goto }];
  }
  return [];
}

export function collectPhoneReplyGotoScenes(options: PhoneChatReplyOption[]): string[] {
  const scenes: string[] = [];
  for (const opt of options) {
    if (opt.goto) scenes.push(opt.goto);
    if (opt.replyOptions?.length) {
      scenes.push(...collectPhoneReplyGotoScenes(opt.replyOptions));
    }
  }
  return scenes;
}

/** Feuilles avec réplique contact et sans sous-choix → goto de convergence. */
export function applyAutoConvergeToPhoneReplies(
  options: PhoneChatReplyOption[],
  convergeSceneId: string
): PhoneChatReplyOption[] {
  return options.map((opt) => {
    const nested = opt.replyOptions?.length
      ? applyAutoConvergeToPhoneReplies(opt.replyOptions, convergeSceneId)
      : undefined;
    const hasNested = (nested?.length ?? 0) > 0;
    const hasContactReply = Boolean(opt.contactReply?.trim());

    let goto = opt.goto;
    if (hasNested) {
      goto = undefined;
    } else if (hasContactReply) {
      goto = convergeSceneId;
    } else if (goto === convergeSceneId) {
      goto = undefined;
    }

    return {
      ...opt,
      goto,
      replyOptions: nested,
    };
  });
}

export function resolvePhoneReplyGotoScene(
  option: PhoneChatReplyOption,
  defaultConvergeSceneId?: string
): string | undefined {
  if (option.replyOptions?.length) return undefined;
  if (option.goto) return option.goto;
  if (option.contactReply?.trim() && defaultConvergeSceneId) {
    return defaultConvergeSceneId;
  }
  return undefined;
}
